/** The password change: the account menu opens it, and login, a must-change session and the API's PASSWORD_CHANGE_REQUIRED force it. */
export const CHANGE_PASSWORD_PATH = '/change-password';
